import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingukComponent } from './reportinguk/reportinguk.component';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { FormsModule } from '@angular/forms';
import { HighchartsChartModule } from 'highcharts-angular';
import { CmsCommonModule } from '../cms-common/cms-common.module';
import { MatTableModule } from '@angular/material/table';

@NgModule({
  declarations: [
    ReportingukComponent,
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    CmsCommonModule,
    HighchartsChartModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusAshfieldDataNewComponent: {
          component: ReportingukComponent
        },
        
      }
    } as CmsConfig)
  ]
})
export class ReportingUKModule { }
